import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { VehicleIdentificationType } from '../../../../vehicle/models/enums/vehicle-identification-type.enum';
import { OmnisearchModel } from '../../../models/search/omnisearch.model';
import { ValidationModel } from '../../../models/validation-results/validation.model';

export class VehicleGenericModalData {
    constructor(public title: string, public results: any, public searchString: string) {}
}

@Component({
    selector: 'vehicle-generic-modal',
    templateUrl: './vehicle-generic-modal.html'
})

export class VehicleGenericModalComponent extends BaseComponent {
    public activeTab = 'VIN';
    public dataLoaded: boolean;
    public results: ValidationModel;
    public searchString: string;
    public showSearchCriteria = true;
    public title: string;
    public vehicleIdentTypes: VehicleIdentificationType = new VehicleIdentificationType();

    constructor(public dialogRef: MatDialogRef<VehicleGenericModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: VehicleGenericModalData) {
        super();
        this.title = data.title;
        this.results = data.results;
        this.searchString = data.searchString;
        this.dataLoaded = false;
    }

    ngOnInit() {
        this.dataLoaded = true;
        this.handleValidationResult(this.results);
    }

    cancel() {
        this.dialogRef.close();
    }

    isTabActive(tabTitle: string) {
        return this.activeTab === tabTitle;
    }

    itemSelected(item: OmnisearchModel | number) {
        this.dialogRef.close(item);
    }

    onTabChanged(tabTitle: string) {
        this.activeTab = tabTitle;
    }
}
